"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseCurrencyType_1 = __importDefault(require("./BaseCurrencyType"));
const TICKER = 'DC';
class DataCredits extends BaseCurrencyType_1.default {
    constructor() {
        super(TICKER, 0);
    }
}
exports.default = DataCredits;
//# sourceMappingURL=DataCredits.js.map